export default {
  title: {
    en: 'Resubscribe',
  },
}
